import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/noDataDark.png';
const _withScopeId = n => (_pushScopeId("data-v-32fb7d22"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container",
  "element-loading-text": "设备导入中..."
};
const _hoisted_2 = {
  class: "top-container searchTop"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  key: 0,
  class: "button-container"
};
const _hoisted_5 = {
  key: 0,
  class: "image-preview-container"
};
const _hoisted_6 = {
  key: 0,
  class: "no-image-tip"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  key: 0,
  class: "dialog-footer"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "30px"
  }
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__tip"
}, " 仅支持xlsx格式的文件 ", -1));
const _hoisted_12 = {
  class: "dialog-footer"
};
const _hoisted_13 = {
  class: "wellDrawerBody"
};
const _hoisted_14 = {
  key: 0,
  class: "runDataitem"
};
const _hoisted_15 = {
  class: "raw-data-content"
};
const _hoisted_16 = {
  class: "raw-data-json"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "raw-data-indicator"
}, " 查看原始上报数据 ", -1));
const _hoisted_18 = {
  key: 1,
  class: "data-item"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "最新数据上报时间", -1));
const _hoisted_20 = {
  class: "data-value"
};
const _hoisted_21 = {
  key: 2,
  class: "data-item"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "电池电量百分比", -1));
const _hoisted_23 = {
  class: "data-value"
};
const _hoisted_24 = {
  key: 3,
  class: "data-item"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "电池状态", -1));
const _hoisted_26 = {
  class: "data-value"
};
const _hoisted_27 = {
  key: 4,
  class: "data-item"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "液位状态", -1));
const _hoisted_29 = {
  class: "data-value"
};
const _hoisted_30 = {
  key: 5,
  class: "data-item"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "配件状态", -1));
const _hoisted_32 = {
  class: "data-value"
};
const _hoisted_33 = {
  key: 6,
  class: "data-item"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "倾斜状态", -1));
const _hoisted_35 = {
  class: "data-value"
};
const _hoisted_36 = {
  key: 7,
  class: "data-item"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "压力状态", -1));
const _hoisted_38 = {
  class: "data-value"
};
const _hoisted_39 = {
  key: 8,
  class: "data-item"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "振动状态", -1));
const _hoisted_41 = {
  class: "data-value"
};
const _hoisted_42 = {
  key: 9,
  class: "data-item"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "温度", -1));
const _hoisted_44 = {
  class: "data-value"
};
const _hoisted_45 = {
  key: 10,
  class: "data-item"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "湿度", -1));
const _hoisted_47 = {
  class: "data-value"
};
const _hoisted_48 = {
  key: 11,
  class: "data-item"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "压力值", -1));
const _hoisted_50 = {
  class: "data-value"
};
const _hoisted_51 = {
  key: 12,
  class: "data-item-out"
};
const _hoisted_52 = {
  class: "data-item"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "信号强度", -1));
const _hoisted_54 = {
  class: "data-value"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-lishishuju"
}, null, -1));
const _hoisted_56 = [_hoisted_55];
const _hoisted_57 = {
  key: 13,
  class: "data-item"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "信噪比", -1));
const _hoisted_59 = {
  class: "data-value"
};
const _hoisted_60 = {
  key: 14,
  class: "data-item"
};
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "信号质量", -1));
const _hoisted_62 = {
  class: "data-value"
};
const _hoisted_63 = {
  key: 0,
  class: "data-item"
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "状态描述", -1));
const _hoisted_65 = {
  class: "data-value"
};
const _hoisted_66 = {
  key: 1,
  class: "data-item"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "气体类型描述", -1));
const _hoisted_68 = {
  class: "data-value"
};
const _hoisted_69 = {
  key: 2,
  class: "data-item"
};
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "气体浓度", -1));
const _hoisted_71 = {
  class: "data-value"
};
const _hoisted_72 = {
  key: 0,
  class: "data-item"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "供电状态描述：", -1));
const _hoisted_74 = {
  class: "data-value"
};
const _hoisted_75 = {
  key: 1,
  class: "data-item"
};
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "主电故障", -1));
const _hoisted_77 = {
  class: "data-value"
};
const _hoisted_78 = {
  key: 2,
  class: "data-item"
};
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "备电故障", -1));
const _hoisted_80 = {
  class: "data-value"
};
const _hoisted_81 = {
  key: 3,
  class: "data-item"
};
const _hoisted_82 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "充电故障", -1));
const _hoisted_83 = {
  class: "data-value"
};
const _hoisted_84 = {
  key: 4,
  class: "data-item"
};
const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "内部故障", -1));
const _hoisted_86 = {
  class: "data-value"
};
const _hoisted_87 = {
  key: 5,
  class: "data-item"
};
const _hoisted_88 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "回路1状态描述：", -1));
const _hoisted_89 = {
  class: "data-value"
};
const _hoisted_90 = {
  key: 6,
  class: "data-item"
};
const _hoisted_91 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "回路2状态描述：", -1));
const _hoisted_92 = {
  class: "data-value"
};
const _hoisted_93 = {
  class: "raw-data-content"
};
const _hoisted_94 = {
  class: "raw-data-json"
};
const _hoisted_95 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "raw-data-indicator"
}, " 查看原始上报数据 ", -1));
const _hoisted_96 = {
  key: 1,
  class: "data-item"
};
const _hoisted_97 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "最新数据上报时间", -1));
const _hoisted_98 = {
  class: "data-value"
};
const _hoisted_99 = {
  key: 2,
  class: "data-item"
};
const _hoisted_100 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "设备UUID", -1));
const _hoisted_101 = {
  class: "data-value"
};
const _hoisted_102 = {
  key: 3,
  class: "data-item"
};
const _hoisted_103 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "设备名称", -1));
const _hoisted_104 = {
  class: "data-value"
};
const _hoisted_105 = {
  key: 4,
  class: "data-item"
};
const _hoisted_106 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "设备型号", -1));
const _hoisted_107 = {
  class: "data-value"
};
const _hoisted_108 = {
  key: 5,
  class: "data-item"
};
const _hoisted_109 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "设备状态", -1));
const _hoisted_110 = {
  class: "data-value"
};
const _hoisted_111 = {
  key: 6,
  class: "data-item"
};
const _hoisted_112 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "注册状态", -1));
const _hoisted_113 = {
  class: "data-value"
};
const _hoisted_114 = {
  key: 7,
  class: "data-item"
};
const _hoisted_115 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "最后在线时间", -1));
const _hoisted_116 = {
  class: "data-value"
};
const _hoisted_117 = {
  key: 8,
  class: "data-item-out"
};
const _hoisted_118 = {
  class: "data-item"
};
const _hoisted_119 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "信号强度", -1));
const _hoisted_120 = {
  class: "data-value"
};
const _hoisted_121 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-lishishuju"
}, null, -1));
const _hoisted_122 = [_hoisted_121];
const _hoisted_123 = {
  key: 9,
  class: "data-item"
};
const _hoisted_124 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "电池电压", -1));
const _hoisted_125 = {
  class: "data-value"
};
const _hoisted_126 = {
  key: 10,
  class: "data-item"
};
const _hoisted_127 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "主电状态", -1));
const _hoisted_128 = {
  class: "data-value"
};
const _hoisted_129 = {
  key: 11,
  class: "data-item"
};
const _hoisted_130 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "备电状态", -1));
const _hoisted_131 = {
  class: "data-value"
};
const _hoisted_132 = {
  key: 12,
  class: "data-item"
};
const _hoisted_133 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "心跳周期(分钟)", -1));
const _hoisted_134 = {
  class: "data-value"
};
const _hoisted_135 = {
  key: 13,
  class: "data-item"
};
const _hoisted_136 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "控制器挂载的探测器总数", -1));
const _hoisted_137 = {
  class: "data-value"
};
const _hoisted_138 = {
  key: 14,
  class: "data-item"
};
const _hoisted_139 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "本帧推送的探测数量", -1));
const _hoisted_140 = {
  class: "data-value"
};
const _hoisted_141 = {
  key: 15,
  class: "data-item"
};
const _hoisted_142 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "纬度", -1));
const _hoisted_143 = {
  class: "data-value"
};
const _hoisted_144 = {
  key: 16,
  class: "data-item"
};
const _hoisted_145 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "经度", -1));
const _hoisted_146 = {
  class: "data-value"
};
const _hoisted_147 = {
  key: 0,
  class: "data-item"
};
const _hoisted_148 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "最新数据上报时间", -1));
const _hoisted_149 = {
  class: "data-value"
};
const _hoisted_150 = {
  key: 1,
  class: "data-item"
};
const _hoisted_151 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "流水号", -1));
const _hoisted_152 = {
  class: "data-value"
};
const _hoisted_153 = {
  key: 2,
  class: "data-item-out"
};
const _hoisted_154 = {
  class: "data-item"
};
const _hoisted_155 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "信号强度", -1));
const _hoisted_156 = {
  class: "data-value"
};
const _hoisted_157 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-lishishuju"
}, null, -1));
const _hoisted_158 = [_hoisted_157];
const _hoisted_159 = {
  key: 3,
  class: "data-item"
};
const _hoisted_160 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "采集状态", -1));
const _hoisted_161 = {
  class: "data-value"
};
const _hoisted_162 = {
  key: 4,
  class: "data-item"
};
const _hoisted_163 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "采集方式", -1));
const _hoisted_164 = {
  class: "data-value"
};
const _hoisted_165 = {
  key: 5,
  class: "data-item"
};
const _hoisted_166 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "传感器总数", -1));
const _hoisted_167 = {
  class: "data-value"
};
const _hoisted_168 = {
  key: 6,
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_169 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-title"
}, " 传感器列表 ", -1));
const _hoisted_170 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_171 = {
  style: {
    "font-weight": "600",
    "color": "#333",
    "margin-bottom": "10px"
  }
};
const _hoisted_172 = {
  class: "chuanganqi"
};
const _hoisted_173 = {
  style: {
    "margin-right": "15px"
  }
};
const _hoisted_174 = {
  class: "raw-data-content"
};
const _hoisted_175 = {
  class: "raw-data-json"
};
const _hoisted_176 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "raw-data-indicator"
}, " 查看原始上报数据 ", -1));
const _hoisted_177 = {
  key: 1,
  class: "data-item"
};
const _hoisted_178 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "最新数据上报时间", -1));
const _hoisted_179 = {
  class: "data-value"
};
const _hoisted_180 = {
  key: 2,
  class: "data-item"
};
const _hoisted_181 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "设备编号", -1));
const _hoisted_182 = {
  class: "data-value"
};
const _hoisted_183 = {
  key: 3,
  class: "data-item"
};
const _hoisted_184 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "设备拓扑结构", -1));
const _hoisted_185 = {
  class: "data-value"
};
const _hoisted_186 = {
  key: 4,
  class: "data-item"
};
const _hoisted_187 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "检测对象", -1));
const _hoisted_188 = {
  class: "data-value"
};
const _hoisted_189 = {
  key: 5,
  class: "data-item"
};
const _hoisted_190 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "设备采集值", -1));
const _hoisted_191 = {
  class: "data-value"
};
const _hoisted_192 = {
  key: 6,
  class: "data-item"
};
const _hoisted_193 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "数据单位", -1));
const _hoisted_194 = {
  class: "data-value"
};
const _hoisted_195 = {
  key: 7,
  class: "data-item"
};
const _hoisted_196 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "事件类型", -1));
const _hoisted_197 = {
  class: "data-value"
};
const _hoisted_198 = {
  key: 1,
  class: "no-data-container"
};
const _hoisted_199 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-data-icon"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-warning-outline"
})], -1));
const _hoisted_200 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-data-text"
}, "暂无运行数据", -1));
const _hoisted_201 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-data-desc"
}, "该设备当前没有上报运行数据", -1));
const _hoisted_202 = [_hoisted_199, _hoisted_200, _hoisted_201];
import { listHwPage, addHwPage, updateHwPage, addXhsPage, updateXhsPage, addXedPage, updateXedPage, delHwPge, delXhsPge, delXedPge, importHwPage, getXedDetailData, getXhsDetailData, getHwDetailData, getHwOnlineData, getXhsOnlineData, getXedOnlineData, addAkxPage, updateAkxPage, delAkxPge, getAkxOnlineData, getAkxDetailData, importXedPage, importAkxPage, importXhsPage, exportAkxAllData } from '@/api/system1/tenant';
import { dictList } from '@/api/deviceManage';
import { ref, unref, reactive, watch, onMounted, nextTick, computed } from 'vue';
import { downloadFlie, download } from '@/utils';
import { useStore } from 'vuex';
import { ElMessageBox, ElMessage } from 'element-plus';
import DeviceStateHistory from "@/components/DeviceStateHistory.vue";
import { useRoute } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const deviceForm = ref(null);
    const store = useStore();
    // 获取用户类型
    const userType = store.state.common.userInfo.userType;
    // 获取当前租户下拉
    const tenantInfos = store.state.common.userInfo.tenantInfos;
    // 所属地区配置
    const cityProps = ref({
      label: 'name',
      value: 'id',
      multiple: false,
      checkStrictly: false
    });
    const formatCode = function (code, column) {
      if (code == 0) {
        return '离线';
      } else if (code == 1) {
        return '在线';
      } else if (code == 2) {
        return '故障';
      } else {
        return '';
      }
    };
    const formatAlarmCode = function (code, column) {
      if (code) {
        return '告警';
      } else {
        return '正常';
      }
    };
    const formatCode1 = function (code, column) {
      if (code == 1) {
        return '已注册';
      } else {
        return '未注册';
      }
    };
    // 传感器状态码文本转换
    const getSensorStatusText = function (status) {
      const statusMap = {
        '0': '探头短路',
        '1': '探头断开',
        '2': '探头老化',
        '3': '其它故障',
        '4': '未标定',
        '5': '零点变化',
        '6': '检测周期过期',
        '7': '无响应',
        '8': '寿命过期',
        '9': '探头自检',
        '10': '正常',
        '11': '屏蔽',
        '13': '预报警',
        '14': '低限报警',
        '15': '高限报警'
      };
      return statusMap[status] || '-';
    };
    const showHistory = ref();
    const showDetailDialog = (indi, unit, name) => {
      let row = {
        id: "",
        indicator: indi,
        opstartTime: "",
        opEndTime: "",
        unit: unit,
        legend: name
      };
      showHistory.value.show(row, "历史数据");
    };
    // 获取压力状态文本
    const getPressureStatusText = function (status) {
      switch (status) {
        case 0:
          return '正常';
        case 1:
          return '一级报警';
        case 2:
          return '二级报警';
        default:
          return '未知';
      }
    };
    const vendorList = ref([]);
    // 状态数据字典
    const statusOptions = ref([{
      dictValue: 0,
      dictLabel: '离线'
    }, {
      dictValue: 1,
      dictLabel: '在线'
    }, {
      dictValue: 2,
      dictLabel: '告警'
    }]);
    const state = reactive({
      // 遮罩层
      loading: true,
      loading1: true,
      exportLoading: false,
      curId: "",
      onlineData: {
        deviceUuid: '',
        timestamp: '',
        serialNumber: null,
        ssid: null,
        acquisitionStatus: '',
        acquisitionType: '',
        sensorData: [],
        sensorTotalNumber: null,
        // 安可信设备运行数据字段
        batteryPercentage: null,
        batteryStatus: null,
        liquidLevelStatus: null,
        accessoryStatus: null,
        tiltStatus: null,
        pressureStatus: null,
        vibrationStatus: null,
        temperature: null,
        humidity: null,
        pressureValue: null,
        rsrp: null,
        snr: null,
        csq: null,
        probes: [{
          'address': null,
          'statusDesc': null,
          'gasTypeDesc': null,
          'concentration': null
        }],
        modules: [{
          output1Status: null,
          output2Status: null
        }],
        powerStatus: {
          statusDesc: null,
          mainPowerFault: null,
          backupPowerFault: null,
          chargeFault: null,
          internalFault: null
        }
      },
      // 当前查看运行数据的厂商代码
      currentVendorCode: null,
      // 安可信设备名称编码
      deviceNameCode: null,
      dialogVisible: false,
      // 选中数组
      ids: [],
      // 选中的完整数据
      selectedRows: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 压力台账表格数据
      roleList: [],
      // 弹出层标题
      title: '',
      uploadForm: {
        tenantId: null,
        vendorCode: null,
        fileList: []
      },
      uploadFormRules: {
        tenantId: [{
          required: true,
          message: '所属租户不能为空',
          trigger: 'change'
        }],
        vendorCode: [{
          required: true,
          message: '厂商名称不能为空',
          trigger: 'change'
        }],
        fileList: [{
          required: true,
          message: '上传文件不能为空',
          trigger: 'blur'
        }]
      },
      // 是否显示弹出层
      open: false,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      isDetail: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        menuType: 7,
        deviceUuid: route.query.actNum || '',
        deviceName: '',
        deviceStatus: null,
        installLocation: '',
        vendorCode: null,
        tenantId: null,
        order: '',
        prop: ''
      },
      showOnlineData: false,
      // 表单参数
      form: {
        'tenantId': null,
        'vendorCode': null,
        'deviceUuid': '',
        'deviceCode': '',
        'deviceName': '',
        'deviceNameCode': '',
        'deviceTypeCode': '',
        // 'deviceModel': '',
        'imei': '',
        'ccid': '',
        'wirelessMode': '',
        'installLocation': '',
        'longitude': '',
        'latitude': '',
        'remark': '',
        imgUrl: []
      },
      // 表单校验
      rules: {
        deviceUuid: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }, {
          max: 20,
          message: '设备编号最多20个字符',
          trigger: 'blur'
        }],
        tenantId: [{
          required: true,
          message: '不能为空',
          trigger: 'change'
        }],
        vendorCode: [{
          required: true,
          message: '不能为空',
          trigger: 'change'
        }],
        deviceNameCode: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }],
        ownerName: [{
          max: 30,
          message: '所属商户最多30个字符',
          trigger: 'blur'
        }],
        deviceName: [{
          max: 30,
          message: '设备名称最多30个字符',
          trigger: 'blur'
        }],
        deviceTypeCode: [{
          max: 20,
          message: '设备类型代码最多20个字符',
          trigger: 'blur'
        }],
        imei: [{
          max: 20,
          message: 'IMEI模组号最多20个字符',
          trigger: 'blur'
        }],
        ccid: [{
          max: 20,
          message: 'CCID最多20个字符',
          trigger: 'blur'
        }],
        installLocation: [{
          max: 50,
          message: '安装位置最多50个字符',
          trigger: 'blur'
        }],
        longitude: [{
          required: true,
          message: '经度不能为空',
          trigger: 'blur'
        }, {
          validator: (rule, value, callback) => {
            if (!value) {
              callback();
              return;
            }
            const numValue = parseFloat(value);
            // 检查是否为有效数字
            if (isNaN(numValue)) {
              callback(new Error('请输入有效的经度数值'));
              return;
            }
            // 检查范围：-180 到 180
            if (numValue < -180 || numValue > 180) {
              callback(new Error('经度范围应在-180到180之间'));
              return;
            }
            // 检查小数位最多20位
            const strValue = value.toString();
            const decimalIndex = strValue.indexOf('.');
            if (decimalIndex !== -1) {
              const decimalPart = strValue.substring(decimalIndex + 1);
              if (decimalPart.length > 20) {
                callback(new Error('经度小数位最多20位'));
                return;
              }
            }
            callback();
          },
          trigger: 'blur'
        }],
        latitude: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }, {
          validator: (rule, value, callback) => {
            if (!value) {
              callback();
              return;
            }
            const numValue = parseFloat(value);
            // 检查是否为有效数字
            if (isNaN(numValue)) {
              callback(new Error('请输入有效的纬度数值'));
              return;
            }
            // 检查范围：-90 到 90
            if (numValue < -90 || numValue > 90) {
              callback(new Error('纬度范围应在-90到90之间'));
              return;
            }
            // 检查小数位最多20位
            const strValue = value.toString();
            const decimalIndex = strValue.indexOf('.');
            if (decimalIndex !== -1) {
              const decimalPart = strValue.substring(decimalIndex + 1);
              if (decimalPart.length > 20) {
                callback(new Error('纬度小数位最多20位'));
                return;
              }
            }
            callback();
          },
          trigger: 'blur'
        }]
      },
      saveLoading: false,
      saveLoading1: false,
      searchFormData: [{
        prop: 'deviceUuid',
        label: '设备编号',
        placeholder: '设备编号',
        type: 'text',
        isSelect: false,
        span: 4
      },
      // {
      //   prop: 'deviceName',
      //   label: '设备名称',
      //   placeholder: '设备名称',
      //   type: 'text',
      //   isSelect: false,
      //   span: 4
      // },
      {
        prop: 'vendorCode',
        label: '厂商名称',
        placeholder: '请选择厂商名称',
        type: 'list',
        isSelect: false,
        filterable: true,
        options: vendorList,
        props: {
          label: 'label',
          value: 'value'
        },
        change: () => {},
        span: 4
      }, {
        prop: 'deviceStatus',
        label: '设备状态',
        placeholder: '请选择设备状态',
        type: 'list',
        isSelect: false,
        filterable: true,
        options: statusOptions,
        props: {
          label: 'dictLabel',
          value: 'dictValue'
        },
        change: () => {},
        span: 4
      }, {
        prop: 'installLocation',
        label: '安装位置',
        placeholder: '请输入安装位置',
        type: 'text',
        isSelect: false,
        span: 4
      }],
      formHandle: [{
        label: '搜索',
        type: 'primary',
        icon: 'el-icon-search',
        class: 'btn-liquid',
        handle: () => handleQuery()
      }, {
        label: '重置',
        icon: 'el-icon-refresh',
        class: 'commonDarkBtn',
        handle: () => resetQuery()
      }],
      // 列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: '新增',
        buttonStyle: 'primary',
        hasPermi: ['Hw:page:add'],
        className: 'addBtn',
        buttonIcon: 'Plus',
        exp: item => handleAdd(item)
      }, {
        buttonName: '导入',
        buttonStyle: 'primary',
        className: 'importBtn',
        buttonIcon: 'Download',
        hasPermi: ['Hw:page:import'],
        exp: () => handleImport()
      }, {
        buttonName: '导出',
        buttonStyle: 'warning',
        hasPermi: ['Hw:page:export'],
        className: 'exportBtn',
        buttonIcon: 'Upload',
        exp: item => handleExport(item)
      }
      // {
      //   buttonName: '删除',
      //   buttonStyle: 'danger',
      //   hasPermi: ['Hw:page:del'],
      //   className: 'deleteBtn',
      //   buttonIcon: 'Delete',
      //   exp: (item) => handleDelete(item),
      //   disabledHandle(row) {
      //     return state.multiple
      //   }
      // }
      ],
      deviceList: [],
      tableHeader: [{
        prop: 'deviceUuid',
        label: '设备编号'
      },
      // {
      //   prop: 'deviceName',
      //   label: '设备名称'
      // },
      // {
      //   prop: 'deviceTypeCode',
      //   label: '设备类型代码'
      // },
      {
        prop: 'ownerName',
        label: '所属商户'
      }, {
        prop: 'vendorName',
        label: '厂商名称'
      },
      // {
      //   prop: 'deviceModel',
      //   label: '设备型号'
      // },
      {
        prop: 'deviceStatus',
        label: '在线状态',
        formatData: formatCode,
        type: function (row) {
          if (row.deviceStatus == 2) {
            return 'error';
          } else if (row.deviceStatus == 1) {
            return 'success';
          } else if (row.deviceStatus == 0) {
            return 'info';
          } else {
            return 'error';
          }
        }
      }, {
        prop: 'hasAlarm',
        label: '告警状态',
        formatData: formatAlarmCode,
        type: function (row) {
          if (row.hasAlarm) {
            return 'error';
          } else {
            return 'success';
          }
        }
      },
      // {
      //   prop: 'registerStatus',
      //   label: '注册状态',
      //   formatData: formatCode1,
      //   type: function (row) {
      //     if (row.registerStatus == 0) {
      //       return 'info'
      //     } else if (row.registerStatus == 1) {
      //       return 'success'
      //     }
      //   }
      // },
      // {
      //   prop: 'imei',
      //   label: 'IMEI模组号'
      // },
      // {
      //   prop: 'ccid',
      //   label: 'CCID'
      // },
      // {
      //   prop: 'wirelessMode',
      //   label: '通讯方式'
      // },
      {
        prop: 'attr1',
        label: '信号强度(dBm)',
        minWidth: 140,
        sort: true
      }, {
        prop: 'longitude',
        label: '经度'
      }, {
        prop: 'latitude',
        label: '纬度'
      }, {
        prop: 'installLocation',
        label: '安装位置',
        minWidth: 150
      }, {
        prop: 'operation',
        label: '操作',
        width: '210px',
        fixed: 'right',
        operation: [{
          name: '查看',
          clickFun: row => handleDetail(row),
          hasPermi: []
        }, {
          name: '修改',
          clickFun: row => handleUpdate(row),
          hasPermi: ['Hw:page:edit']
        }, {
          name: '删除',
          clickFun: row => handleDelete(row),
          hasPermi: ['Hw:page:del']
        }, {
          name: '运行数据',
          clickFun: row => handleView(row),
          hasPermi: ['Hw:page:rundata'],
          showTooltip: true,
          tooltipContent: '查看原始上报数据'
        }]
      }]
    });
    // 计算属性：获取有效的图片列表（过滤空值并添加前缀）
    const getImageList = computed(() => {
      if (!state.form.imgUrl || !Array.isArray(state.form.imgUrl)) {
        return [];
      }
      const prefix = window.g?.imgUrlPrex || '';
      return state.form.imgUrl.filter(img => img && img.trim() !== '').map(img => {
        const imgUrl = img.trim();
        // 如果URL已经是完整路径（以http://或https://开头），则不添加前缀
        if (imgUrl.startsWith('http://') || imgUrl.startsWith('https://')) {
          return imgUrl;
        }
        // 否则添加前缀
        return prefix + imgUrl;
      });
    });
    onMounted(() => {
      if (userType != 3) {
        state.uploadForm.tenantId = state.form.tenantId = window.localStorage.getItem('tenantId');
      }
      getVendorList();
    });
    // 查询厂商名称字典数据
    const getVendorList = function () {
      dictList({
        'codeList': ['device_registory_vendor_code']
      }).then(response => {
        vendorList.value = response.data['device_registory_vendor_code'];
      });
    };
    /** 查询压力台账列表 */
    const getList = function () {
      state.loading = true;
      // 告警特殊处理
      const params = {
        ...state.queryParams
      };
      if (state.queryParams.deviceStatus == 2) {
        delete params.deviceStatus;
        params.hasAlarm = 1;
      }
      listHwPage(params).then(response => {
        state.roleList = {
          rows: response.data.records,
          total: response.data.total
        };
        state.loading = false;
      }).catch(() => {
        state.loading = false;
      });
    };

    // 取消按钮（数据权限）
    const cancelDataScope = function () {
      state.openDataScope = false;
      reset();
    };
    const cancel = function () {
      state.open = false;
      state.deviceNameCode = null;
    };

    // 表单重置
    const reset = function () {
      state.form = {
        'deviceUuid': '',
        'deviceCode': '',
        'deviceName': '',
        'deviceTypeCode': '',
        'deviceNameCode': '',
        // 'deviceModel': '',
        'imei': '',
        'ccid': '',
        'wirelessMode': '',
        'installLocation': '',
        'longitude': '',
        'latitude': '',
        'remark': '',
        imgUrl: []
      };
      if (userType != 3) {
        state.uploadForm.tenantId = state.form.tenantId = window.localStorage.getItem('tenantId');
      }
    };
    // 排序
    const sortEvents = column => {
      state.queryParams.prop = column.prop;
      state.queryParams.order = column.order == 'ascending' ? 'asc' : 'desc';
      getList();
      console.log(column);
    };
    /** 搜索按钮操作 */
    const handleQuery = function () {
      state.queryParams.pageNum = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.dateRange = [];
      state.queryParams = {
        pageNum: 1,
        pageSize: 10,
        menuType: 7,
        deviceUuid: '',
        deviceName: '',
        installLocation: '',
        deviceStatus: null,
        vendorCode: null,
        order: '',
        prop: ''
      };
      if (userType != 3) {
        state.uploadForm.tenantId = state.form.tenantId = window.localStorage.getItem('tenantId');
      }
      handleQuery();
    };
    // 多选框选中数据
    const handleSelectionChange = function (selection) {
      state.ids = selection.map(item => item.id);
      state.selectedRows = selection;
      state.single = selection.length != 1;
      state.multiple = !selection.length;
    };
    /** 新增按钮操作 */
    const handleAdd = function () {
      state.openDataScope = true;
      state.title = '添加台账';
      state.isDetail = false;
      state.code = '';
      reset();
    };
    const clearValidate = prop => {
      deviceForm.value.clearValidate(prop);
    };

    /** 修改按钮操作 */
    const handleUpdate = function (row) {
      state.title = '修改台账';
      state.isDetail = false;
      state.form.imgUrl = [];
      state.openDataScope = true;
      // 根据厂商代码选择对应的详情接口
      const vendorCode = row.vendorCode;
      let detailApi = null;
      if (vendorCode == 4) {
        // 鑫豪斯
        detailApi = getXhsDetailData;
      } else if (vendorCode == 5) {
        // 汉威
        detailApi = getHwDetailData;
      } else if (vendorCode == 6) {
        // 希尔得
        detailApi = getXedDetailData;
      } else if (vendorCode == 3) {
        // 安可信
        detailApi = getAkxDetailData;
      }
      if (row.vendorDeviceId) {
        detailApi(row.vendorDeviceId).then(response => {
          if (response.code == 0) {
            state.form = {
              ...response.data
            };
            const imgList = state.form.imgUrl ? state.form.imgUrl.split(',') : [];
            state.form.imgUrl = imgList;
          } else {
            state.form = {
              ...row
            };
            const imgList = state.form.imgUrl ? state.form.imgUrl.split(',') : [];
            state.form.imgUrl = imgList;
          }
          state.form.vendorCode = row.vendorCode.toString();
          state.form.vendorDeviceId = row.vendorDeviceId;
        }).catch(() => {});
      }
    };
    /** 修改/新增压力台账提交按钮*/
    const submitDataScope = function () {
      const formRef = unref(deviceForm);
      formRef.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          const params = {
            ...state.form
          };
          if (state.form.imgUrl.length > 0) {
            params.imgUrl = state.form.imgUrl.join(',');
          } else {
            params.imgUrl = '';
          }
          params.deviceCode = state.form.deviceUuid;
          console.log(params, 'params---');
          // 根据厂商代码判断调用哪个接口
          const vendorCode = state.form.vendorCode;
          console.log(vendorCode, 'vendorCode');
          let addApi = null;
          let updateApi = null;
          // 根据厂商代码匹配对应的接口
          if (vendorCode == 3) {
            // 安可信
            addApi = addAkxPage;
            updateApi = updateAkxPage;
            params.deviceModel = 'AEC2626T';
            params.devicePurpose = 2;
          } else if (vendorCode == 4) {
            // 鑫豪斯
            addApi = addXhsPage;
            updateApi = updateXhsPage;
          } else if (vendorCode == 5) {
            // 汉威
            addApi = addHwPage;
            updateApi = updateHwPage;
          } else if (vendorCode == 6) {
            // 希尔得
            addApi = addXedPage;
            updateApi = updateXedPage;
          }
          if (!updateApi || !addApi) {
            return;
          }
          if (state.form.id) {
            // 编辑
            params.id = state.form.vendorDeviceId;
            console.log(params, 'params---');
            updateApi(params).then(response => {
              if (response.code == 0) {
                ElMessage.success('修改成功');
                state.openDataScope = false;
                getList();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            // 新增
            addApi(params).then(response => {
              if (response.code == 0) {
                ElMessage.success('新增成功');
                state.openDataScope = false;
                // 新增后重置
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    // 导入
    const downloadTemplate = function () {
      const vendorCode = state.uploadForm.vendorCode;
      let templateUrl = '';
      if (vendorCode == 3) {
        // 安可信
        templateUrl = '/ty-iot-manage/api/v1/ankexin/device/exportTemplate';
      } else if (vendorCode == 4) {
        // 鑫豪斯
        templateUrl = '/ty-iot-manage/api/v1/xhs/device/exportTemplate';
      } else if (vendorCode == 5) {
        // 汉威
        templateUrl = '/ty-iot-manage/api/v1/hanwei/device/exportTemplate';
      } else if (vendorCode == 6) {
        // 希尔得
        templateUrl = '/ty-iot-manage/api/v1/xed/device/exportTemplate';
      }
      if (!vendorCode) {
        ElMessage.warning('请选择厂商');
        return;
      }
      if (!templateUrl) {
        ElMessage.warning('暂无模板');
        return;
      }
      downloadFlie(templateUrl);
    };
    const handleImport = function () {
      state.uploadForm.fileList = [];
      state.uploadForm.vendorCode = null;
      state.dialogVisible = true;
    };
    /** 导出文件 */
    const handleExport = function () {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认导出数据项?', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        const params = {
          ...state.queryParams
        };
        if (state.queryParams.deviceStatus == 2) {
          delete params.deviceStatus;
          params.hasAlarm = 1;
        }
        exportAkxAllData(params).then(res => {
          if (res.status === 200) {
            const fileName = decodeURI(res.headers['content-disposition'].split("utf-8''")[1]);
            download(res.data, fileName);
          }
        }).catch(() => {});
      });
    };
    const closeUpload = function () {
      state.dialogVisible = false;
      state.uploadForm.vendorCode = null;
      state.uploadForm.tenantId = null;
      state.uploadForm.fileList = [];
    };
    const handleRemove = function () {
      const formRef = unref(ruleFormRef);
      state.uploadForm.fileList = [];
      formRef.validate();
    };
    const uploadRef = ref(null);
    const submitUpload = function (formEl) {
      const upload = unref(uploadRef);
      formEl.validate(valid => {
        if (valid) {
          upload.submit();
        }
      });
    };
    const ruleFormRef = ref(null);
    const uploadChange = function (file, list) {
      const formRef = unref(ruleFormRef);
      const fileName = file.name.split('.').pop().toLowerCase();
      if (!['xlsx'].includes(fileName)) {
        state.uploadForm.fileList = [];
        ElMessage.warning('文件类型只支持xlsx格式！');
        formRef.validate();
        return;
      }
      state.uploadForm.fileList = [file];
      formRef.validate();
    };
    const uploadFile = function (params) {
      state.exportLoading = true;
      const formData = new FormData();
      formData.append('file', params.file);
      if (state.uploadForm.tenantId && state.uploadForm.tenantId != 'null') {
        formData.append('tenantId', state.uploadForm.tenantId);
      }
      const vendorCode = state.uploadForm.vendorCode;
      let importApi = null;
      if (vendorCode == 3) {
        // 安可信
        importApi = importAkxPage;
      } else if (vendorCode == 4) {
        // 鑫豪斯
        importApi = importXhsPage;
      } else if (vendorCode == 5) {
        // 汉威
        importApi = importHwPage;
      } else if (vendorCode == 6) {
        // 希尔得
        importApi = importXedPage;
      }
      if (!importApi) {
        ElMessage.warning('暂无导入接口');
        return;
      }
      importApi(formData).then(res => {
        state.saveLoading = false;
        state.exportLoading = false;
        state.dialogVisible = false;
        ElMessage.closeAll();
        if (res.code == 0) {
          if (res?.data?.code == 1001) {
            ElMessage.error(res?.data?.message);
          } else {
            ElMessage.success('导入成功！');
          }
          getList();
        } else {
          ElMessage.error(res.message);
        }
      }).catch(error => {
        ElMessage.closeAll();
        ElMessage.warning(error);
        state.saveLoading = false;
        state.exportLoading = false;
      });
    };
    const handleView = function (row) {
      state.loading1 = true;
      state.open = true;
      state.currentVendorCode = row.vendorCode;
      state.curId = row.id;
      // 根据厂商代码判断调用哪个运行数据接口
      const vendorCode = row.vendorCode;
      let onlineDataApi = null;
      const deviceId = row.deviceUuid;
      if (vendorCode == 3) {
        // 安可信
        onlineDataApi = getAkxOnlineData;
        // 设置设备名称编码
        state.deviceNameCode = row.deviceNameCode || null;
      } else if (vendorCode == 4) {
        // 鑫豪斯
        onlineDataApi = getXhsOnlineData;
        state.deviceNameCode = null;
      } else if (vendorCode == 5) {
        // 汉威
        onlineDataApi = getHwOnlineData;
        state.deviceNameCode = null;
      } else if (vendorCode == 6) {
        // 希尔得
        onlineDataApi = getXedOnlineData;
        state.deviceNameCode = null;
      }
      onlineDataApi(deviceId).then(res => {
        if (res.data) {
          state.showOnlineData = true;
          state.onlineData = res.data;
        } else {
          state.showOnlineData = false;
        }
        state.loading1 = false;
      }).catch(() => {
        state.loading1 = false;
        state.showOnlineData = false;
      });
    };
    const handleDetail = function (row) {
      state.title = '查看详情';
      const vendorCode = row.vendorCode;
      let detailApi = null;
      if (vendorCode == 4) {
        // 鑫豪斯
        detailApi = getXhsDetailData;
      } else if (vendorCode == 5) {
        // 汉威
        detailApi = getHwDetailData;
      } else if (vendorCode == 6) {
        // 希尔得
        detailApi = getXedDetailData;
      } else if (vendorCode == 3) {
        // 安可信
        detailApi = getAkxDetailData;
      }
      if (!detailApi) {
        return;
      }
      state.isDetail = true;
      state.form.imgUrl = [];
      state.openDataScope = true;
      // 调用详情接口获取数据
      detailApi(row.vendorDeviceId).then(response => {
        if (response.code == 0 && response.data) {
          state.form = {
            ...response.data
          };
          const imgList = state.form.imgUrl ? state.form.imgUrl.split(',') : [];
          state.form.imgUrl = imgList;
        }
        state.form.vendorCode = row.vendorCode.toString();
      }).catch(() => {});
    };
    /** 删除按钮操作 */
    const handleDelete = function (row) {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认删除数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        const vendorCode = row.vendorCode;
        let deleteApi = null;
        if (vendorCode == 3) {
          // 安可信
          deleteApi = delAkxPge;
        } else if (vendorCode == 4) {
          // 鑫豪斯
          deleteApi = delXhsPge;
        } else if (vendorCode == 5) {
          // 汉威
          deleteApi = delHwPge;
        } else if (vendorCode == 6) {
          // 希尔得
          deleteApi = delXedPge;
        }
        if (!deleteApi) {
          return;
        }
        return deleteApi(row.vendorDeviceId);
      }).then(res => {
        getList();
        ElMessage.success('删除成功');
      }).catch(function (error) {
        console.error('删除失败:', error);
      });
    };
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_image = _resolveComponent("el-image");
      const _component_EIUploadMutiplePic = _resolveComponent("EIUploadMutiplePic");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: state.queryParams,
        formData: state.searchFormData,
        formHandle: state.formHandle
      }, null, 8, ["form", "formData", "formHandle"])]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          loading: item.loading,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, _ctx.form),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "icon", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.roleList,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onGetList: getList,
        hasSelect: true,
        columnSetting: false,
        onSelectionChange: handleSelectionChange,
        onSortEvents: sortEvents
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]]), _createVNode(_component_commonDrawer, {
        modelValue: state.openDataScope,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => state.openDataScope = $event),
        size: "550px",
        title: state.title,
        "close-on-click-modal": false,
        disabled: state.isDetail,
        onClose: cancelDataScope
      }, {
        footer: _withCtx(() => [!state.isDetail ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitDataScope,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form, {
          disabled: state.isDetail,
          model: state.form,
          "status-icon": "",
          "label-width": "120px",
          ref_key: "deviceForm",
          ref: deviceForm,
          rules: state.rules,
          class: "commonForm",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 15
          }, {
            default: _withCtx(() => [_unref(userType) == 3 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "所属租户",
                prop: "tenantId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.tenantId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.form.tenantId = $event),
                  placeholder: "请选择所属租户"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tenantInfos), (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.tenantName,
                      value: item.tenantId,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "厂商名称",
                prop: "vendorCode"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.vendorCode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.form.vendorCode = $event),
                  placeholder: "请选择厂商名称"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vendorList.value, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "所属商户",
                prop: "ownerName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.ownerName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => state.form.ownerName = $event),
                  placeholder: "请输入所属商户最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备编号",
                prop: "deviceUuid"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.deviceUuid,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => state.form.deviceUuid = $event),
                  disabled: !!state.form.id,
                  placeholder: "请输入设备编号最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备名称",
                prop: "deviceName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.deviceName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => state.form.deviceName = $event),
                  placeholder: "请输入设备名称最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), state.form.vendorCode == 3 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备名称编码",
                prop: "deviceNameCode"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.deviceNameCode,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => state.form.deviceNameCode = $event),
                  placeholder: "请输入设备名称编码最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备类型代码",
                prop: "deviceTypeCode"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.deviceTypeCode,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => state.form.deviceTypeCode = $event),
                  placeholder: "请输入设备类型代码最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备图片",
                prop: "imgUrl"
              }, {
                default: _withCtx(() => [state.isDetail ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getImageList), (img, index) => {
                  return _openBlock(), _createBlock(_component_el_image, {
                    key: index,
                    src: img,
                    "preview-src-list": _unref(getImageList),
                    "initial-index": index,
                    fit: "cover",
                    class: "preview-image",
                    "preview-teleported": true
                  }, null, 8, ["src", "preview-src-list", "initial-index"]);
                }), 128)), !_unref(getImageList) || _unref(getImageList).length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true)])) : (_openBlock(), _createBlock(_component_EIUploadMutiplePic, {
                  key: 1,
                  "file-list": state.form.imgUrl,
                  "onUpdate:fileList": _cache[8] || (_cache[8] = $event => state.form.imgUrl = $event),
                  limit: 3,
                  onClearValidate: _cache[9] || (_cache[9] = $event => clearValidate(state.form.imgUrl)),
                  uploadTip: "最多上传3张图片"
                }, null, 8, ["file-list"]))]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "IMEI模组号",
                prop: "imei"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.imei,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => state.form.imei = $event),
                  placeholder: "请输入IMEI模组号最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "CCID",
                prop: "ccid"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.ccid,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => state.form.ccid = $event),
                  placeholder: "请输入CCID(SIM卡号)最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "安装位置",
                prop: "installLocation"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.installLocation,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => state.form.installLocation = $event),
                  placeholder: "请输入安装位置最多50个字符",
                  maxlength: "50",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "经度",
                prop: "longitude"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.longitude,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => state.form.longitude = $event),
                  placeholder: "请输入经度"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "纬度",
                prop: "latitude"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.latitude,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => state.form.latitude = $event),
                  placeholder: "请输入纬度"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.remark,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => state.form.remark = $event),
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入备注信息最多200个字符",
                  maxlength: "200",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled", "model", "rules"])])]),
        _: 1
      }, 8, ["modelValue", "title", "disabled"]), _createVNode(_component_commonDrawer, {
        title: "导入设备",
        modelValue: state.dialogVisible,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => state.dialogVisible = $event),
        width: "500px",
        "close-on-click-modal": false,
        "before-close": closeUpload
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[19] || (_cache[19] = $event => submitUpload(ruleFormRef.value))
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: closeUpload
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          "auto-upload": false,
          model: state.uploadForm,
          rules: state.uploadFormRules,
          "status-icon": "",
          "label-width": "120px",
          class: "commonForm"
        }, {
          default: _withCtx(() => [_hoisted_10, _unref(userType) == 3 ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "所属租户",
              prop: "tenantId"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: state.uploadForm.tenantId,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => state.uploadForm.tenantId = $event),
                placeholder: "请选择所属租户"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tenantInfos), (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: item.tenantName,
                    value: item.tenantId,
                    key: index
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "厂商名称",
              prop: "vendorCode"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: state.uploadForm.vendorCode,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => state.uploadForm.vendorCode = $event),
                placeholder: "请选择厂商名称"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vendorList.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: item.label,
                    value: item.value,
                    key: index
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "模板"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: downloadTemplate
            }, {
              default: _withCtx(() => [_createTextVNode("下载模板")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "文件",
            prop: "fileList"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              ref_key: "uploadRef",
              ref: uploadRef,
              "auto-upload": false,
              class: "upload-demo",
              action: "",
              "on-remove": handleRemove,
              "file-list": state.uploadForm.fileList,
              "on-change": uploadChange,
              "http-request": uploadFile
            }, {
              tip: _withCtx(() => [_hoisted_11]),
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("上传文件")]),
                _: 1
              })]),
              _: 1
            }, 8, ["file-list"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_commonDrawer, {
        modelValue: state.open,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => state.open = $event),
        size: "600px",
        title: "运行数据",
        "close-on-click-modal": false,
        onClose: cancel,
        class: "wellDrawer"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [state.showOnlineData ? (_openBlock(), _createElementBlock("div", _hoisted_14, [state.currentVendorCode == 3 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [state.showOnlineData ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          placement: "bottom",
          trigger: "click",
          "show-after": 0,
          "hide-after": 0,
          width: 400,
          effect: "light",
          "popper-class": "raw-data-tooltip"
        }, {
          content: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("pre", _hoisted_16, _toDisplayString(JSON.stringify(state.onlineData, null, 2)), 1)])]),
          default: _withCtx(() => [_hoisted_17]),
          _: 1
        })) : _createCommentVNode("", true), state.onlineData?.timestamp ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_hoisted_19, _createElementVNode("span", _hoisted_20, _toDisplayString(state.onlineData?.timestamp), 1)])) : _createCommentVNode("", true), state.onlineData?.batteryPercentage !== null ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_hoisted_22, _createElementVNode("span", _hoisted_23, _toDisplayString(state.onlineData?.batteryPercentage) + "%", 1)])) : _createCommentVNode("", true), state.onlineData?.batteryStatus !== null ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_hoisted_25, _createElementVNode("span", _hoisted_26, _toDisplayString(state.onlineData?.batteryStatus === 1 ? '低电' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.liquidLevelStatus !== null ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_hoisted_28, _createElementVNode("span", _hoisted_29, _toDisplayString(state.onlineData?.liquidLevelStatus === 1 ? '浸没' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.accessoryStatus !== null ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_hoisted_31, _createElementVNode("span", _hoisted_32, _toDisplayString(state.onlineData?.accessoryStatus === 1 ? '异常' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.tiltStatus !== null ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_hoisted_34, _createElementVNode("span", _hoisted_35, _toDisplayString(state.onlineData?.tiltStatus === 1 ? '异动' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.pressureStatus !== null ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_hoisted_37, _createElementVNode("span", _hoisted_38, _toDisplayString(getPressureStatusText(state.onlineData?.pressureStatus)), 1)])) : _createCommentVNode("", true), state.onlineData?.vibrationStatus !== null ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_hoisted_40, _createElementVNode("span", _hoisted_41, _toDisplayString(state.onlineData?.vibrationStatus === 1 ? '告警' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.temperature !== null ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_hoisted_43, _createElementVNode("span", _hoisted_44, _toDisplayString(state.onlineData?.temperature) + "°C", 1)])) : _createCommentVNode("", true), state.onlineData?.humidity !== null ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_hoisted_46, _createElementVNode("span", _hoisted_47, _toDisplayString(state.onlineData?.humidity) + "%", 1)])) : _createCommentVNode("", true), state.onlineData?.pressureValue !== null ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_hoisted_49, _createElementVNode("span", _hoisted_50, _toDisplayString(state.onlineData?.pressureValue) + "Pa", 1)])) : _createCommentVNode("", true), state.onlineData?.csq !== null ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_hoisted_53, _createElementVNode("span", _hoisted_54, _toDisplayString(state.onlineData?.csq) + "dBm", 1)]), _createElementVNode("span", {
          class: "indicator",
          onClick: _cache[21] || (_cache[21] = $event => showDetailDialog('attr1', 'dBm', '信号强度'))
        }, _hoisted_56)])) : _createCommentVNode("", true), state.onlineData?.snr !== null ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_hoisted_58, _createElementVNode("span", _hoisted_59, _toDisplayString(state.onlineData?.snr) + "dB", 1)])) : _createCommentVNode("", true), state.onlineData?.csq !== null ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_hoisted_61, _createElementVNode("span", _hoisted_62, _toDisplayString(state.onlineData?.csq), 1)])) : _createCommentVNode("", true), state.deviceNameCode == '08' || state.deviceNameCode == '0A' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 15
        }, [state.onlineData?.probes[0]?.statusDesc !== null ? (_openBlock(), _createElementBlock("div", _hoisted_63, [_hoisted_64, _createElementVNode("span", _hoisted_65, _toDisplayString(state.onlineData?.probes[0]?.statusDesc), 1)])) : _createCommentVNode("", true), state.onlineData?.probes[0]?.gasTypeDesc !== null ? (_openBlock(), _createElementBlock("div", _hoisted_66, [_hoisted_67, _createElementVNode("span", _hoisted_68, _toDisplayString(state.onlineData?.probes[0]?.gasTypeDesc), 1)])) : _createCommentVNode("", true), state.onlineData?.probes[0]?.concentration !== null ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_hoisted_70, _createElementVNode("span", _hoisted_71, _toDisplayString(state.onlineData?.probes[0]?.concentration), 1)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), state.deviceNameCode == '01' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 16
        }, [state.onlineData?.powerStatus?.statusDesc !== null ? (_openBlock(), _createElementBlock("div", _hoisted_72, [_hoisted_73, _createElementVNode("span", _hoisted_74, _toDisplayString(state.onlineData?.powerStatus?.statusDesc), 1)])) : _createCommentVNode("", true), state.onlineData?.powerStatus?.mainPowerFault !== null ? (_openBlock(), _createElementBlock("div", _hoisted_75, [_hoisted_76, _createElementVNode("span", _hoisted_77, _toDisplayString(state.onlineData?.powerStatus?.mainPowerFault ? '告警' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.powerStatus?.backupPowerFault !== null ? (_openBlock(), _createElementBlock("div", _hoisted_78, [_hoisted_79, _createElementVNode("span", _hoisted_80, _toDisplayString(state.onlineData?.powerStatus?.backupPowerFault ? '告警' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.powerStatus?.chargeFault !== null ? (_openBlock(), _createElementBlock("div", _hoisted_81, [_hoisted_82, _createElementVNode("span", _hoisted_83, _toDisplayString(state.onlineData?.powerStatus?.chargeFault ? '告警' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.powerStatus?.internalFault !== null ? (_openBlock(), _createElementBlock("div", _hoisted_84, [_hoisted_85, _createElementVNode("span", _hoisted_86, _toDisplayString(state.onlineData?.powerStatus?.internalFault ? '告警' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.modules?.length > 0 && state.onlineData?.modules[0]?.output1Status !== null ? (_openBlock(), _createElementBlock("div", _hoisted_87, [_hoisted_88, _createElementVNode("span", _hoisted_89, _toDisplayString(state.onlineData?.modules[0]?.output1Status), 1)])) : _createCommentVNode("", true), state.onlineData?.modules?.length > 0 && state.onlineData?.modules[0]?.output2Status !== null ? (_openBlock(), _createElementBlock("div", _hoisted_90, [_hoisted_91, _createElementVNode("span", _hoisted_92, _toDisplayString(state.onlineData?.modules[0]?.output2Status), 1)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 64)) : state.currentVendorCode == 4 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [state.onlineData?.configJson ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          placement: "bottom",
          trigger: "click",
          "show-after": 0,
          "hide-after": 0,
          width: 400,
          effect: "light",
          "popper-class": "raw-data-tooltip"
        }, {
          content: _withCtx(() => [_createElementVNode("div", _hoisted_93, [_createElementVNode("pre", _hoisted_94, _toDisplayString(JSON.stringify(state.onlineData?.configJson, null, 2)), 1)])]),
          default: _withCtx(() => [_hoisted_95]),
          _: 1
        })) : _createCommentVNode("", true), state.onlineData?.lastReportTime ? (_openBlock(), _createElementBlock("div", _hoisted_96, [_hoisted_97, _createElementVNode("span", _hoisted_98, _toDisplayString(state.onlineData?.lastReportTime), 1)])) : _createCommentVNode("", true), state.onlineData?.deviceUuid ? (_openBlock(), _createElementBlock("div", _hoisted_99, [_hoisted_100, _createElementVNode("span", _hoisted_101, _toDisplayString(state.onlineData?.deviceUuid), 1)])) : _createCommentVNode("", true), state.onlineData?.deviceName ? (_openBlock(), _createElementBlock("div", _hoisted_102, [_hoisted_103, _createElementVNode("span", _hoisted_104, _toDisplayString(state.onlineData?.deviceName), 1)])) : _createCommentVNode("", true), state.onlineData?.deviceModel ? (_openBlock(), _createElementBlock("div", _hoisted_105, [_hoisted_106, _createElementVNode("span", _hoisted_107, _toDisplayString(state.onlineData?.deviceModel), 1)])) : _createCommentVNode("", true), state.onlineData?.deviceStatus !== null && state.onlineData?.deviceStatus !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_108, [_hoisted_109, _createElementVNode("span", _hoisted_110, _toDisplayString(state.onlineData?.deviceStatus == 0 ? '离线' : state.onlineData?.deviceStatus == 1 ? '在线' : state.onlineData?.deviceStatus == 2 ? '故障' : '-'), 1)])) : _createCommentVNode("", true), state.onlineData?.registerStatus !== null && state.onlineData?.registerStatus !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_111, [_hoisted_112, _createElementVNode("span", _hoisted_113, _toDisplayString(state.onlineData?.registerStatus == 0 ? '未注册' : state.onlineData?.registerStatus == 1 ? '已注册' : '-'), 1)])) : _createCommentVNode("", true), state.onlineData?.lastOnlineTime ? (_openBlock(), _createElementBlock("div", _hoisted_114, [_hoisted_115, _createElementVNode("span", _hoisted_116, _toDisplayString(state.onlineData?.lastOnlineTime), 1)])) : _createCommentVNode("", true), state.onlineData?.csq !== null ? (_openBlock(), _createElementBlock("div", _hoisted_117, [_createElementVNode("div", _hoisted_118, [_hoisted_119, _createElementVNode("span", _hoisted_120, _toDisplayString(state.onlineData?.csq) + "dBm", 1)]), _createElementVNode("span", {
          class: "indicator",
          onClick: _cache[22] || (_cache[22] = $event => showDetailDialog('attr1', 'dBm', '信号强度'))
        }, _hoisted_122)])) : _createCommentVNode("", true), state.onlineData?.batteryVoltage !== null && state.onlineData?.batteryVoltage !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_123, [_hoisted_124, _createElementVNode("span", _hoisted_125, _toDisplayString(state.onlineData?.batteryVoltage), 1)])) : _createCommentVNode("", true), state.onlineData?.mainPowerStatus !== null && state.onlineData?.mainPowerStatus !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_126, [_hoisted_127, _createElementVNode("span", _hoisted_128, _toDisplayString(state.onlineData?.mainPowerStatus == 0 ? '故障' : state.onlineData?.mainPowerStatus == 1 ? '正常' : '-'), 1)])) : _createCommentVNode("", true), state.onlineData?.batBackupStatus !== null && state.onlineData?.batBackupStatus !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_129, [_hoisted_130, _createElementVNode("span", _hoisted_131, _toDisplayString(state.onlineData?.batBackupStatus == 0 ? '故障' : state.onlineData?.batBackupStatus == 1 ? '正常' : '-'), 1)])) : _createCommentVNode("", true), state.onlineData?.heartbeatTime !== null && state.onlineData?.heartbeatTime !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_132, [_hoisted_133, _createElementVNode("span", _hoisted_134, _toDisplayString(state.onlineData?.heartbeatTime), 1)])) : _createCommentVNode("", true), state.onlineData?.detectorTotal !== null && state.onlineData?.detectorTotal !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_135, [_hoisted_136, _createElementVNode("span", _hoisted_137, _toDisplayString(state.onlineData?.detectorTotal), 1)])) : _createCommentVNode("", true), state.onlineData?.detectorNum !== null && state.onlineData?.detectorNum !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_138, [_hoisted_139, _createElementVNode("span", _hoisted_140, _toDisplayString(state.onlineData?.detectorNum), 1)])) : _createCommentVNode("", true), state.onlineData?.latitude ? (_openBlock(), _createElementBlock("div", _hoisted_141, [_hoisted_142, _createElementVNode("span", _hoisted_143, _toDisplayString(state.onlineData?.latitude), 1)])) : _createCommentVNode("", true), state.onlineData?.longitude ? (_openBlock(), _createElementBlock("div", _hoisted_144, [_hoisted_145, _createElementVNode("span", _hoisted_146, _toDisplayString(state.onlineData?.longitude), 1)])) : _createCommentVNode("", true)], 64)) : state.currentVendorCode == 5 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [state.onlineData?.timestamp ? (_openBlock(), _createElementBlock("div", _hoisted_147, [_hoisted_148, _createElementVNode("span", _hoisted_149, _toDisplayString(state.onlineData?.timestamp), 1)])) : _createCommentVNode("", true), state.onlineData?.serialNumber !== null && state.onlineData?.serialNumber !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_150, [_hoisted_151, _createElementVNode("span", _hoisted_152, _toDisplayString(state.onlineData?.serialNumber), 1)])) : _createCommentVNode("", true), state.onlineData?.ssid !== null ? (_openBlock(), _createElementBlock("div", _hoisted_153, [_createElementVNode("div", _hoisted_154, [_hoisted_155, _createElementVNode("span", _hoisted_156, _toDisplayString(state.onlineData?.ssid) + "dBm ", 1)]), _createElementVNode("span", {
          class: "indicator",
          onClick: _cache[23] || (_cache[23] = $event => showDetailDialog('attr1', 'dBm', '信号强度'))
        }, _hoisted_158)])) : _createCommentVNode("", true), state.onlineData?.acquisitionStatus ? (_openBlock(), _createElementBlock("div", _hoisted_159, [_hoisted_160, _createElementVNode("span", _hoisted_161, _toDisplayString(state.onlineData?.acquisitionStatus), 1)])) : _createCommentVNode("", true), state.onlineData?.acquisitionType ? (_openBlock(), _createElementBlock("div", _hoisted_162, [_hoisted_163, _createElementVNode("span", _hoisted_164, _toDisplayString(state.onlineData?.acquisitionType), 1)])) : _createCommentVNode("", true), state.onlineData?.sensorTotalNumber !== null && state.onlineData?.sensorTotalNumber !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_165, [_hoisted_166, _createElementVNode("span", _hoisted_167, _toDisplayString(state.onlineData?.sensorTotalNumber), 1)])) : _createCommentVNode("", true), state.onlineData?.sensorData && state.onlineData?.sensorData.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_168, [_hoisted_169, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.onlineData.sensorData, (sensor, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "data-item",
            key: index
          }, [_createElementVNode("div", _hoisted_170, [_createElementVNode("div", _hoisted_171, _toDisplayString(sensor.name || `传感器${sensor.addr}`), 1), _createElementVNode("div", _hoisted_172, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_173, "地址: " + _toDisplayString(sensor.addr), 1), _createElementVNode("span", null, "状态: " + _toDisplayString(getSensorStatusText(sensor.status)), 1)]), _createElementVNode("div", null, _toDisplayString(sensor.val) + " " + _toDisplayString(sensor.unit || ''), 1)])])]);
        }), 128))])) : _createCommentVNode("", true)], 64)) : state.currentVendorCode == 6 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 3
        }, [state.onlineData?.rawPayload ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          placement: "bottom",
          trigger: "click",
          "show-after": 0,
          "hide-after": 0,
          width: 400,
          effect: "light",
          "popper-class": "raw-data-tooltip"
        }, {
          content: _withCtx(() => [_createElementVNode("div", _hoisted_174, [_createElementVNode("pre", _hoisted_175, _toDisplayString(JSON.stringify(state.onlineData?.rawPayload, null, 2)), 1)])]),
          default: _withCtx(() => [_hoisted_176]),
          _: 1
        })) : _createCommentVNode("", true), state.onlineData?.ts ? (_openBlock(), _createElementBlock("div", _hoisted_177, [_hoisted_178, _createElementVNode("span", _hoisted_179, _toDisplayString(state.onlineData?.ts), 1)])) : _createCommentVNode("", true), state.onlineData?.deviceUuid ? (_openBlock(), _createElementBlock("div", _hoisted_180, [_hoisted_181, _createElementVNode("span", _hoisted_182, _toDisplayString(state.onlineData?.deviceUuid), 1)])) : _createCommentVNode("", true), state.onlineData?.channelCode ? (_openBlock(), _createElementBlock("div", _hoisted_183, [_hoisted_184, _createElementVNode("span", _hoisted_185, _toDisplayString(state.onlineData?.channelCode), 1)])) : _createCommentVNode("", true), state.onlineData?.monitorObject ? (_openBlock(), _createElementBlock("div", _hoisted_186, [_hoisted_187, _createElementVNode("span", _hoisted_188, _toDisplayString(state.onlineData?.monitorObject), 1)])) : _createCommentVNode("", true), state.onlineData?.concentration !== null && state.onlineData?.concentration !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_189, [_hoisted_190, _createElementVNode("span", _hoisted_191, _toDisplayString(state.onlineData?.concentration), 1)])) : _createCommentVNode("", true), state.onlineData?.dataUnit !== null && state.onlineData?.dataUnit !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_192, [_hoisted_193, _createElementVNode("span", _hoisted_194, _toDisplayString(state.onlineData?.dataUnit), 1)])) : _createCommentVNode("", true), state.onlineData?.eventCode !== null && state.onlineData?.eventCode !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_195, [_hoisted_196, _createElementVNode("span", _hoisted_197, _toDisplayString(state.onlineData?.eventCode), 1)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_198, _hoisted_202))])), [[_directive_loading, state.loading1]])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(DeviceStateHistory, {
        ref_key: "showHistory",
        ref: showHistory,
        id: state.curId
      }, null, 8, ["id"])])), [[_directive_loading, state.exportLoading]]);
    };
  }
};